import React from "react";

export const Payumoney = () => {
  return <div>Payumoney</div>;
};
